import Roof from './roof.js'
let text = window.text; // We depend on global localization

//TODO: Need also to include heights in calculations

export default class GambrelRoof extends Roof {
  constructor(r,p) {
    super(r,p)

    this.inputs = [
      {
        name: "length",
        title: text.length
      },
      {
        name: "widthf",
        title: text.widthf
      },
      {
        name: "widths",
        title: text.widths
      },
      {
        name: "heightf",
        title: text.heightf,
        alternatives:{
          names: ["anglef"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "heightf"){
              return height;
            }
            return Roof.angle(height,values["widthf"]*2)*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "heightf"){
              return propertyValue;
            }
            let angle = propertyValue*Roof.degreeToRadian();
            return Roof.angleToHeight(values["widthf"]*2, angle);
          },
        },
      },
      {
        name: "heights",
        title: text.heights,
        alternatives:{
          names: ["angles"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "heights"){
              return height;
            }
            return Roof.angle(height,values["widths"]*2)*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "heights"){
              return propertyValue;
            }
            let angle = propertyValue*Roof.degreeToRadian();
            return Roof.angleToHeight(values["widths"]*2, angle);
          },
        },
      },
    ]

    this.name = text.rGambel
    this.description = text.rdGambel
  }

  anglefToHeightf(anglef){
    // Factor two to account for not being divided by two
    return Roof.angleToHeight(this.props.widthf*2, anglef);
    //return Math.tan(anglef/180*Math.PI)*(this.props.widthf);
  }

  anglesToHeights(angles){
    return Roof.angleToHeight(this.props.widths*2, angles);
    //return Math.tan(angles/180*Math.PI)*(this.props.widths);
  }

	pipes() {
		let i = this.props
		return [i.length, i.length]
  }
  
  vindski() {
    let vindskiLow = Math.sqrt(this.props.widthf*this.props.widthf, 
                                this.props.heightf*this.props.heightf);
    let vindskiHigh = Math.sqrt(this.props.widths*this.props.widths,
                                  this.props.heights*this.props.heights);
    return 4*vindskiLow + 4*vindskiHigh
  }

  mone() {
    return this.props.length * 3.0;
  }

  topatches() {
    let wflatf = Math.sqrt(this.props.widthf*this.props.widthf +
          this.props.heightf*this.props.heightf);
    let wflats = Math.sqrt(this.props.widths*this.props.widths +
          this.props.heights*this.props.heights);
    let patches = [
      this.fromrect(1000*this.props.length, 1000 * wflatf),
      this.fromrect(1000*this.props.length, 1000 * wflatf),
      this.fromrect(1000*this.props.length, 1000 * wflats),
      this.fromrect(1000*this.props.length, 1000 * wflats),
    ];
    return patches
  }

  patchtransforms() {
    let wflatf = Math.sqrt(this.props.widthf*this.props.widthf +
          this.props.heightf*this.props.heightf);
    let wflats = Math.sqrt(this.props.widths*this.props.widths +
          this.props.heights*this.props.heights);

    let l = this.props.length/2*1000;
    let w1 = wflatf*1000;
    let w2 = wflats*1000;
    //let w1 = this.props.pw1*1000;
    //let w2 = this.props.pw2*1000;

    let off = (w1+w2)/20
    return [
      {
        t: [-l, -w1-w2-off*1.5],
        r: [0, 0, 0],
      },
      {
        t: [-l, -w1-w2-off*1.5],
        r: [180, 0, 0],
      },
      {
        t: [-l, -w2-off/2],
        r: [0, 0, 0],
      },
      {
        t: [-l, -w2-off/2],
        r: [180, 0, 0],
      },
    ]
  }

  validateInput(inputs){
    if (inputs == undefined){
      return undefined;
    }
    return undefined;
  }

}



// WEBPACK FOOTER //
// ./roofs/gambrelroof.js